import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import React, { useEffect, useState } from 'react';
import './index.scss';

export default function InputComponent(props) {
  const {
    multiline = false,
    validator,
    defaultValue = '',
    inputType = 'text',
    label,
    fullWidth,
    componentContStyle,
    onValueChange,
    customerError = 'login-page.error',
    errorValue,
    inputTextStyle,
    errorCondition = (data) => !data || data === '',
    helperTextStyle,
    iconStyle
  } = props;

  const { t } = useTranslation();

  const [value, setValue] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, []);

  const handleChange = (e) => {
    e.stopPropagation();
    const newValue = e.target.value;
    if (validator) {
      const errorMessage = validator(newValue, t(customerError));
      setError(errorMessage);
      onValueChange(!errorMessage ? newValue : errorValue);
    } else {
      onValueChange(newValue);
    }
    setValue(newValue);
  };

  return (
    <FormControl
      className="input-component"
      error={!!error || errorCondition(value)}
      variant="standard"
      fullWidth={fullWidth}
      sx={componentContStyle}
    >
      <InputLabel
        htmlFor="component-error"
        sx={inputTextStyle}
      >
        {label}
      </InputLabel>
      <Input
        multiline={multiline}
        id="component-error"
        aria-describedby="component-error-text"
        defaultValue={defaultValue}
        value={value}
        sx={{ color: value ? undefined : '#B2B3B3', ...inputTextStyle }}
        inputProps={{ type : inputType }}
        onChange={handleChange}
        onBlur={() => {
          if (value === '') setError(false);
        }}
      />
      {!!error &&
        <FormHelperText
          style={helperTextStyle}
          id="component-error-text"
        >
          <ErrorIcon style={iconStyle} />
          {t(error)}
        </FormHelperText>
      }
    </FormControl>
  );
}